import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

// One navigation for every sheet except the plate ("/"), which carries its own
// sheet references. Opaque at all times; it never reacts to scroll.
const ITEMS = [
  { label: "MAP", to: "/" },
  { label: "WORK", to: "/work" },
  { label: "CV", to: "/cv" },
  { label: "NOTES", to: "/notes" },
  { label: "GITHUB", href: "https://github.com/Lizo-RoadTown" },
  { label: "LINKEDIN", href: "https://www.linkedin.com/in/elizosborn" },
];

// "/cv" and "/cv/" are the same place. Exactly one item can match, because
// every internal destination is distinct and the comparison is exact: the old
// navbar tested a hash link and a path prefix as different kinds of link.
const normalize = (p) => (p.length > 1 ? p.replace(/\/+$/, "") : p) || "/";

const SiteNav = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const here = normalize(pathname);

  useEffect(() => setOpen(false), [pathname]);

  return (
    <nav
      className={`site-nav${open ? " is-open" : ""}`}
      aria-label="Site"
      onKeyDown={(e) => e.key === "Escape" && setOpen(false)}
    >
      <div className="site-nav__inner">
        <button
          type="button"
          className="site-nav__toggle"
          aria-expanded={open}
          aria-controls="site-nav-links"
          onClick={() => setOpen((v) => !v)}
        >
          MENU
        </button>
        <ul id="site-nav-links" className="site-nav__links">
          {ITEMS.map((it) => (
            <li key={it.label}>
              {it.href ? (
                <a href={it.href} rel="noreferrer" className="site-nav__link">
                  {it.label}
                  <span className="site-nav__sr"> (external site)</span>
                </a>
              ) : (
                <Link
                  to={it.to}
                  className="site-nav__link"
                  aria-current={here === it.to ? "page" : undefined}
                  onClick={() => setOpen(false)}
                >
                  {it.label}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default SiteNav;
